export default __webpack_public_path__ + "static/media/Hats10.272e4b51.png";